<template>
  <h2 class="pb-2 border-bottom">Opções de tratamento com PRP que podemos oferecer</h2>
  <ul>
    <li><strong>PRP para Rejuvenescimento Facial (“Vampire Facial”)</strong>
      <ul>
        <li>Estimula a produção de colágeno e melhora a textura da pele</li>
        <li>Reduz linhas finas, rugas e cicatrizes de acne</li>
        <li>Restaura o brilho e a elasticidade</li>
      </ul>
    </li>
    <li><strong>PRP para Restauração Capilar</strong>
      <ul>
        <li>Fortalece os folículos capilares e reduz a queda de cabelo</li>
        <li>Estimula o crescimento de novos cabelos</li>
        <li>Ideal para alopecia androgênica (calvície masculina/feminina)</li>
      </ul>
    </li>
    <li><strong>PRP para Terapia de Articulações e Dor</strong>
      <ul>
        <li>Ajuda na artrite, tendinite e recuperação de lesões</li>
        <li>Reduz inflamação e dor em articulações e músculos</li>
        <li>Frequentemente usado para dor no joelho, ombro e cotovelo</li>
      </ul>
    </li>
    <li><strong>PRP para Bem-Estar Sexual</strong>
      <ul>
        <li>O-Shot (para mulheres) – Melhora a função sexual, excitação e incontinência urinária</li>
        <li>P-Shot (para homens) – Aumenta a função erétil e a sensibilidade</li>
      </ul>
    </li>
    <li><strong>PRP para Redução de Cicatrizes e Estrias</strong>
      <ul>
        <li>Melhora a textura da pele e reduz a pigmentação</li>
        <li>Eficaz para cicatrizes de acne, cicatrizes pós-cirúrgicas e estrias</li>
      </ul>
    </li>
  </ul>

  <h2 class="pb-2 border-bottom">Visão Geral do Procedimento PRP</h2>
  <ul>
    <li><strong>Coleta de Sangue</strong> – Uma pequena quantidade de sangue é retirada do paciente</li>
    <li><strong>Processo de Centrifugação</strong> – O sangue é centrifugado para separar o plasma rico em plaquetas</li>
    <li><strong>Aplicação de PRP</strong> – Injetado ou aplicado via microagulhamento com base no tratamento</li>
    <li><strong>Recuperação e Cuidados Pós-Operatórios</strong> – Tempo de inatividade mínimo, leve inchaço ou vermelhidão por 24-48 horas</li>
  </ul>
  <p><strong>Tempo de Procedimento:</strong> 30-60 minutos</p>
  <p><strong>Tempo de Recuperação:</strong> 1-3 dias para tratamentos de pele, mínimo para tratamentos capilares e articulares</p>
</template>

<script>
export default {
  name: 'PRPMicroneedlingFacialContentPtBR'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
